import { ReactComponent as Logo } from "./icons/logo.svg";
import { ReactComponent as SlashIcon } from "./icons/slash.svg";
import { ReactComponent as MailIcon } from "./icons/mail.svg";
import { ReactComponent as PhoneIcon } from "./icons/phone.svg";
import { ReactComponent as CircleCheckedIcon } from "./icons/circle-checked.svg";
import { ReactComponent as CheckedIcon } from "./icons/checked.svg";
import { ReactComponent as ContrastIcon } from "./icons/contrast.svg";
import { ReactComponent as DeafIcon } from "./icons/deaf.svg";
import { ReactComponent as PlusCircleIcon } from "./icons/plus-circle.svg";
import { ReactComponent as MinusCircleIcon } from "./icons/minus-circle.svg";
import { ReactComponent as AIcon } from "./icons/A.svg";
import { ReactComponent as InfoIcon } from "./icons/info.svg";
import { ReactComponent as AngleTopIcon } from "./icons/angle-top.svg";
import { ReactComponent as AngleBottomIcon } from "./icons/angle-bottom.svg";
import { ReactComponent as ClockIcon } from "./icons/clock.svg";
import { ReactComponent as MapIcon } from "./icons/map.svg";
import { ReactComponent as CircleCloseIcon } from "./icons/circle-close.svg";
import { ReactComponent as CUIcon } from "./icons/cu.svg";
import { ReactComponent as ArrowLeftCircleIcon } from "./icons/arrow-left-circle.svg";
import { ReactComponent as SignLanguageIcon } from "./icons/sign-language.svg";
import { ReactComponent as EndCallIcon } from "./icons/end-call.svg";
import { ReactComponent as MovieIcon } from "./icons/movie.svg";
import { ReactComponent as CloseIcon } from "./icons/close.svg";
import { ReactComponent as DownloadIcon } from "./icons/download.svg";
import { ReactComponent as AccessibilityIcon } from "./icons/accessibility.svg";
import { ReactComponent as RegIcon } from "./icons/reg.svg";
import { ReactComponent as PadlockIcon } from "./icons/padlock.svg";
import { ReactComponent as PlusIcon } from "./icons/plus.svg";
import { ReactComponent as MinusIcon } from "./icons/minus.svg";
import { ReactComponent as BipIcon } from "./icons/bip.svg";
import { ReactComponent as CoinsIcon } from "./icons/coins.svg";
import { ReactComponent as SquareArrowRightIcon } from "./icons/square-arrow-right.svg";


export { 
	MailIcon, PhoneIcon, SlashIcon, Logo, ContrastIcon, 
	DeafIcon, PlusCircleIcon, MinusCircleIcon, AIcon, CloseIcon,
	InfoIcon, AngleTopIcon, AngleBottomIcon, CircleCheckedIcon, 
	CheckedIcon, ClockIcon, MapIcon, CircleCloseIcon, CUIcon,
	ArrowLeftCircleIcon, SignLanguageIcon, EndCallIcon, MovieIcon, 
	DownloadIcon, AccessibilityIcon, RegIcon, PadlockIcon,
	PlusIcon, MinusIcon, BipIcon, CoinsIcon, SquareArrowRightIcon 
};